import { http } from '@/api/client/httpClient';
import type { PagedResult } from '@/api/types/abp';
import type { Select2Option } from '@/components/forms/Select2';
import type {
  JournalAccessByDeviceDto,
  JournalAccessByDeviceRequest,
  JournalAccessByIpDto,
  JournalAccessByIpRequest,
} from '@/api/types/relatedClients';

const BASE = '/api/app/related-clients';
const PREP = '/api/app/related-clients-filters-preparation';

interface ResultDto<T> {
  value: T;
  text: string;
}

export const relatedClientsApi = {
  getDataByIp: (input: JournalAccessByIpRequest) =>
    http.get<PagedResult<JournalAccessByIpDto>>(`${BASE}/data-by-ip`, { params: input }).then((r) => r.data),
  getDataByDevice: (input: JournalAccessByDeviceRequest) =>
    http.get<PagedResult<JournalAccessByDeviceDto>>(`${BASE}/data-by-device`, { params: input }).then((r) => r.data),
  getConnectorWarning: (year: number | null) =>
    http.get<{ message?: string | null }>(`${BASE}/connector-warning`, { params: { year } }).then((r) => r.data),

  async getYears(): Promise<Select2Option[]> {
    const { data } = await http.get<PagedResult<ResultDto<number>>>(`${PREP}/years`);
    return (data.items ?? []).map((r) => ({ value: r.value, label: r.text }));
  },
  async getTypes(): Promise<Select2Option[]> {
    const { data } = await http.get<PagedResult<ResultDto<number>>>(`${PREP}/types`);
    return (data.items ?? []).map((r) => ({ value: r.value, label: r.text }));
  },
  async getCountries(): Promise<Select2Option[]> {
    const { data } = await http.get<ResultDto<number>[]>(`${PREP}/countries`);
    return (data ?? []).map((r) => ({ value: r.value, label: r.text }));
  },
};
